import type { SmsSubscriptionState } from '@/app/users/api/useSmsSubscriptionApi'

// ---------------------------------------------------------------------------
// The signed-in user's marketing SMS subscription state for the current brand,
// published as a module singleton by <SmsSubscriptionStateBootstrap /> in
// AppProviders (GSE-12330). Same shape as the brand flag in
// useSmsMarketingEnabled.ts, but deliberately its own module: several test
// files factory-mock that one with only its two flag exports.
//
// Consumer: smsOptInModalQueue.ts reads isSmsMarketingSubscribed() synchronously
// at event time, so the footer and SMS-only modals never open for someone who
// is already on the list — including an opt-in made while logged out that the
// backend has since tied to the account by its phone number. The React
// surfaces (order-confirmation card, My Account row) keep reading
// useSmsSubscriptionApi directly.
// ---------------------------------------------------------------------------

let state: SmsSubscriptionState | null = null

/**
 * Publish the latest subscription read. null when logged out, while the read
 * has not resolved, or when the brand holds no record for this user.
 */
export const setSmsSubscriptionState = (next: SmsSubscriptionState | null): void => {
  state = next
}

/** Synchronous getter for non-React callers (smsOptInModalQueue.ts). */
export const isSmsMarketingSubscribed = (): boolean => state === 'SUBSCRIBED'
